import PropTypes from 'prop-types';
import React from 'react';

import { getContentText } from '../../services/content-text';
import styles from './simple-renderer.scss';

const Renderer = ({ contentState, excerpt, maxLength }) => {
  const text = excerpt ? excerpt.slice(0, maxLength) : getContentText(contentState).slice(0, maxLength);
  return (
    <div data-hook="post-description">
      <p className={styles.content}>{text}</p>
    </div>
  );
};

Renderer.propTypes = {
  contentState: PropTypes.object,
  excerpt: PropTypes.string,
  maxLength: PropTypes.number,
};

export default Renderer;
